// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2c7Iw","error":"Textarea_error__nfzdC","readonly":"Textarea_readonly__DB6e0","disabled":"Textarea_disabled__ngsPU"};